// extracted by mini-css-extract-plugin
module.exports = {"line-scale":"styles_line-scale__3EmN3","fullPageLoader":"styles_fullPageLoader__-aRug"};